import type { Validation, ValidationError } from "io-ts";
import { reporter } from "io-ts-reporters";
import { E, type io, pipe } from "../prelude";
export class DecoderError {
  public readonly type: "DecoderError" = "DecoderError" as const;
  constructor(
    readonly errors: ValidationError[],
    readonly errorMessages: string[],
  ) {}
}

export const mkDecoderError =
  <A>(validation: Validation<A>) =>
  (errors: ValidationError[]): DecoderError => {
    return new DecoderError(errors, reporter(validation));
  };

export const applyDecoder = <I, O>(decoder: io.Decoder<I, O>, data: I) => {
  const validation = decoder.decode(data);
  return pipe(validation, E.mapLeft(mkDecoderError(validation)));
};

export function keyObject<T extends readonly string[]>(arr: T): { [K in T[number]]: null } {
  return Object.fromEntries(arr.map((v) => [v, null])) as { [K in T[number]]: null };
}
